var zIndexSet = {
  // Z-index
  below: -1,
  "default": 1,
  gnb: 500,
  gnbSticky: 500,
  wrapper: 10,
  modal: 50,
  popover: 20,
  toast: 1500,
  tooltip: 1000,
  fullscreen: 1000,
  bottomSheet: 1400
};

export { zIndexSet as default };
